import { useTheme } from '@mui/material/styles';

export const IconChecked = () => {
  const { palette } = useTheme();

  return (
    <svg data-test="icon-checked" fill="none" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14" cy="14" r="13.5" fill="white" stroke={palette.primary.main} />
      <rect x="6.5" y="6.5" width="15" height="15" rx="7.5" fill={palette.primary.main} />
    </svg>
  );
};

export const IconCheckedDisabled = () => {
  const { palette } = useTheme();

  return (
    <svg data-test="icon-checked-disabled" fill="none" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14" cy="14" r="13.5" fill="white" stroke={palette.action.disabled} />
      <rect x="6.5" y="6.5" width="15" height="15" rx="7.5" fill={palette.action.disabled} />
    </svg>
  );
};

export const IconUnchecked = () => {
  const { palette } = useTheme();

  return (
    <svg data-test="icon-unchecked" fill="none" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14" cy="14" r="13.5" fill="white" stroke={palette.divider} />
    </svg>
  );
};

export const IconUncheckedDisabled = () => {
  const { palette } = useTheme();

  return (
    <svg data-test="icon-unchecked-disabled" fill="none" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
      <circle cx="14" cy="14" r="13.5" fill={palette.action.disabled} stroke={palette.background.boxDarker} />
    </svg>
  );
};
